import { petcoTheme } from './petcoTheme';

const petcoPreventiveCareColors = {
  blue: '#12668C',
  gradientLight: '#12668C',
  gradientDark: '#0A3E55',
};

export const petcoPreventiveCareTheme = {
  ...petcoTheme,
  primary: {
    ...petcoTheme.primary,
    main: petcoPreventiveCareColors.blue,
  },
  gradient: {
    light: petcoPreventiveCareColors.gradientLight,
    dark: petcoPreventiveCareColors.gradientDark,
  },
};
